<template>
  <div>
    <div class="top">
      <div class="text">
        <div class="title">
          Online Survey
        </div>
        <div class="value">
          Our extensive panels around the Asian region. We support our clients by managing surveys and other online research practices through these panels.

        </div>
        <div><button @click="contact">REQUEST A BID</button></div>
      </div>
    </div>

    <div class="logo">
      <div class="title">We connect with people through our proprietary panels and alliance partners</div>
      <div class="value">
        <div class="img" @click="$router.push('/physicians')">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/hxl.png">
          <div class="text">HCPs Panel</div>
        </div>
        <div class="img" @click="$router.push('/patients')">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/flc.png">
          <div class="text">Patients Panel</div>
        </div>
        <div class="img" @click="$router.push('/consumer')">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/djs.png">
          <div class="text">Consumer Panel</div>
        </div>
        <div class="img">
          <a href="https://www.appa360.com" target="_blank">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/appa/APPA.png">
            <div class="text">APPA Panel</div>
          </a>
        </div>
      </div>
    </div>

    <div class="icon">
      <div class="box">
        <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/onlineSurvey/survey1.png"></div>
        <div class="value">Extensive 4 Million+ panelists of HCP / Patients / Consumers / Biz Professionals panels across the Asian region</div>
      </div>
      <div class="box">
        <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/onlineSurvey/survey2.png"></div>
        <div class="value">Efficient online methodology</div>
      </div>
      <div class="box">
        <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/onlineSurvey/survey3.png"></div>
        <div class="value">Precise project management</div>
      </div>
    </div>

    <div class="online">
      <div class="title">Online Quantitative Surveys
      </div>
      <div class="value">
        <div class="first">
          As the Asia Pacific online research pioneer, Holden has been providing professional operation service to the global and regional research agency clients for over a decade. Our quantitative research services including:

        </div>
        <div class="second">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/onlineSurvey/survey1.jpg">
          <div class="text">Online survey questionnaire localization and programming</div>

        </div>
        <div class="second">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/onlineSurvey/survey2.jpg">
          <div class="text">Online data collection, by accessing over 4 million families across Asia</div>

        </div>
        <div class="second">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/onlineSurvey/survey3.jpg">
          <div class="text">Data processing and charting</div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { advertisementFlow } from "@/api/api";

export default {
  data() {
    return {};
  },
  created() {
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "onlineSurvey",
          source: "",
          information: "Solutions_onlineSurvey"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "onlineSurvey",
          source: this.$route.query.source,
          information: "Solutions_onlineSurvey"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    contact() {
      let routeData = this.$router.resolve({ path: "/contact?source=bid" });
      window.open(routeData.href, "_blank");
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    }
  }
};
</script>

<style lang="scss" scoped>
.top {
  padding: 170px 200px;
  // height: 600px;
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/onlineSurvey/surveybg.png");
  background-size: cover;
  .text {
    color: #fff;
    width: 60%;
    .title {
      width: 70%;
      font-size: 50px;
      font-weight: 700;
      margin-bottom: 25px;
    }
    .value {
      font-size: 20px;
    }
    button {
      border: none;
      background-color: #2cb1e9;
      color: #fff;
      font-size: 20px;
      border-radius: 10px;
      margin-top: 20px;
      padding: 10px;
    }
  }
}
.logo {
  background-color: #fff;

  padding: 50px 120px;
  .title {
    font-size: 40px;
    font-weight: 700;
  }
  .value {
    padding: 50px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    text-align: center;
    .img {
      // width: 25%;
      img {
        height: 100px;
      }
      .text {
        font-size: 23px;
        padding-top: 30px;
        color: #2cb1e9;
        font-weight: 700;
      }
    }
  }
  .img {
    cursor: pointer;
  }
}
.icon {
  padding: 120px;
  padding-bottom: 0;
  // text-align: center;
  // display: flex;
  // justify-content: space-between;
  .box {
    // width: 30%;
    display: flex;
    padding-bottom: 80px;
    justify-content: space-around;
    align-items: center;
    img {
      width: 220px;
    }
    .value {
      background-color: #2cb1e9;
      color: #fff;
      display: flex;
      align-items: center;
      padding: 20px;
      height: 220px;
      width: 55%;
      font-size: 23px;
      // margin-top: 30px;
      font-weight: 700;
    }
  }
}
.online {
  padding: 50px 120px;
  .title {
    font-size: 40px;
    font-weight: 700;
  }
  .value {
    padding: 50px;
    font-size: 23px;
    .first {
      margin-bottom: 30px;
    }
    .second {
      display: flex;
      margin-top: 20px;
      font-weight: 700;
      img {
        width: 300px;
      }
      .text {
        display: inline-block;
        padding-top: 70px;
        padding-left: 30px;
      }
    }
  }
}
@media screen and (max-width: 576px) {
  .top {
    padding: 80px 100px;
    .text {
      width: 100%;
      .title {
        width: 80%;
        font-size: 110px;
      }
      .value {
        font-size: 70px;
      }
      button {
        font-size: 70px;
        padding: 10px 20px;
      }
    }
  }
  .icon {
    .box {
      img {
        width: 300px;
      }
      .value {
        font-size: 60px;
        height: 700px;
      }
    }
  }
  .online {
    .title {
      font-size: 80px;
    }
    .value {
      font-size: 70px;
      .second {
        display: block;
        img {
          width: 90%;
          margin-top: 200px;
        }
      }
    }
  }
  .logo {
    .title {
      font-size: 80px;
    }
    .value {
      .img {
        width: 90%;
        img {
          height: 500px;
        }
        .text {
          font-size: 80px;
          margin-bottom: 200px;
        }
      }
    }
  }
}
</style>